import React from 'react';
import { GridIcon, ListIcon } from 'lucide-react';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useRoleTheme } from '../../hooks/useRoleTheme';
interface ViewModeToggleProps {
  viewMode: 'grid' | 'list';
  setViewMode: (mode: 'grid' | 'list') => void;
  className?: string;
}
const ViewModeToggle: React.FC<ViewModeToggleProps> = ({
  viewMode,
  setViewMode,
  className = ''
}) => {
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  return <div className={`flex items-center ${className}`} data-id="element-3920" data-mp="16d0s27e9334g">
      <span className={`text-sm mr-3 ${dk.textSecondary}`} data-id="element-3921" data-mp="16bfyajzrfo7n">View as:</span>
      <div className={`flex border rounded-lg overflow-hidden ${dk.isDark ? 'border-gray-700' : 'border-gray-300'}`} data-id="element-3922" data-mp="1bbu9gawnre9w">
        <button onClick={() => setViewMode('grid')} className={`p-2 transition-colors ${viewMode === 'grid' ? dk.isDark ? 'bg-indigo-900/50 text-indigo-400' : 'bg-indigo-100 text-indigo-500' : dk.isDark ? 'bg-gray-800 text-gray-400 hover:bg-gray-700' : 'bg-white text-gray-600 hover:bg-gray-50'}`} aria-label="Grid view" aria-pressed={viewMode === 'grid'} data-id="element-3923" data-mp="1fcw9uv2b9wdg">
          <GridIcon className="h-5 w-5" data-id="element-3924" data-mp="31iqtpd52has0" />
        </button>
        <button onClick={() => setViewMode('list')} className={`p-2 transition-colors ${viewMode === 'list' ? dk.isDark ? 'bg-indigo-900/50 text-indigo-400' : 'bg-indigo-100 text-indigo-500' : dk.isDark ? 'bg-gray-800 text-gray-400 hover:bg-gray-700' : 'bg-white text-gray-600 hover:bg-gray-50'}`} aria-label="List view" aria-pressed={viewMode === 'list'} data-id="element-3925" data-mp="2wmsby8e8ur0k">
          <ListIcon className="h-5 w-5" data-id="element-3926" data-mp="3faxb12jyhnt1" />
        </button>
      </div>
    </div>;
};
export default ViewModeToggle;